var exports = {
  "ZW": "starredIcon__LwlNJ2",
  "V0": "IconOnlyWhenNarrow__FbBSx0",
  "YQ": "HiddenWhenNarrow__RaVogt",
  "kg": "ResponsiveButtonGroup__AWo49d",
};

module.exports = exports;
